<template>
    <el-drawer
        title="导入题目"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel fx-g1" >
            <template>
            <el-form ref="form1" :model="form" label-width="150px" class="edit_form"  >
               <el-form-item label="编程语言" v-check="{'必选': !form.lessonType}">
                   <el-select v-model="form.lessonType" placeholder="编程语言" prop="name">
                       <el-option
                           v-for="item in lessonTypes"
                           :key="item.optionValue"
                           :label="item.optionText"
                           :value="item.optionValue">
                       </el-option>
                   </el-select>
               </el-form-item>
               </el-form>
                 <el-tabs v-model="activeName" @tab-click="handleClick">
                     <el-tab-pane label="单选题" name="first" :model="form">
                        <el-form ref="form" :model="form" label-width="150px" class="edit_form"  >
                           <!-- <el-form-item label="编程语言" v-check="{'必选': !form.lessonType}">
                               <el-select v-model="form.lessonType" placeholder="编程语言" prop="name">
                                   <el-option
                                       v-for="item in lessonTypes"
                                       :key="item.optionValue"
                                       :label="item.optionText"
                                       :value="item.optionValue">
                                   </el-option>
                               </el-select>
                           </el-form-item> -->
                           <el-form-item label="单选题数量" >
                                 <el-input-number v-model="form.singleCount"  :min="0" :max="100"  label=""></el-input-number>
                           </el-form-item>
                           <el-form-item label="单选题分数" >
                                <el-input-number v-model="form.singleScore"  :min="0" :max="100"  label=""></el-input-number>
                           </el-form-item>
                           <el-form-item label="单选题分类">
                              <el-select v-model="form.singleCategorys" multiple placeholder="请选择分类">
                                 <el-option
                                   v-for="item in categorys"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                                 </el-option>
                              </el-select>
                           </el-form-item>
                           <el-form-item label="单选题难度">
                               <el-select v-model="form.singleLevels" multiple placeholder="请选择难度">
                                   <el-option
                                     v-for="item in difficultyOption"
                                     :key="item.id"
                                     :label="item.name"
                                     :value="item.id">
                                   </el-option>
                               </el-select>
                           </el-form-item>
                           <el-form-item label="单选题知识点">
                               <el-cascader placeholder="设置知识点" style="width:300px;"
                                   v-model="form.singleKnowledgeIds" clearable
                                   :options="options"
                                   :props="{expandTrigger: 'hover',
                                   multiple: true
                                   }"
                                   :show-all-levels="false"
                                   @change="handleChange"></el-cascader>
                           </el-form-item>
                        </el-form>
                     </el-tab-pane>
                     <el-tab-pane label="填空题" name="second">
                         <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                              <el-form-item label="填空题数量" >
                                  <el-input-number v-model="form.blanksCount"  :min="0" :max="100"  label=""></el-input-number>
                              </el-form-item>
                              <el-form-item label="填空题分数" >
                                   <el-input-number v-model="form.blanksScore"  :min="0" :max="100"  label=""></el-input-number>
                              </el-form-item>
                              <el-form-item label="填空题分类">
                                    <el-select v-model="form.blanksCategorys" multiple placeholder="请选择分类">
                                       <el-option
                                         v-for="item in categorys"
                                         :key="item.id"
                                         :label="item.name"
                                         :value="item.id">
                                       </el-option>
                                    </el-select>
                              </el-form-item>
                              <el-form-item label="填空题难度">
                                   <el-select v-model="form.blanksLevels" multiple placeholder="请选择难度">
                                       <el-option
                                         v-for="item in difficultyOption"
                                         :key="item.id"
                                         :label="item.name"
                                         :value="item.id">
                                       </el-option>
                                   </el-select>
                              </el-form-item>
                              <el-form-item label="填空题知识点">
                                    <el-cascader placeholder="设置知识点" style="width:300px;"
                                        v-model="form.blanksKnowledgeIds" clearable
                                        :options="options"
                                        :props="{expandTrigger: 'hover',
                                        multiple: true
                                        }"
                                        :show-all-levels="false"
                                        @change="handleChange"></el-cascader>
                              </el-form-item>
                         </el-form>
                     </el-tab-pane>
                     <el-tab-pane label="判断题" name="third">
                         <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                             <el-form-item label="判断题数量">
                                   <el-input-number v-model="form.judgmentCount"  :min="0" :max="100"  label=""></el-input-number>
                              </el-form-item>
                              <el-form-item label="判断题分数" >
                                  <el-input-number v-model="form.judgmentScore"  :min="0" :max="100"  label=""></el-input-number>
                              </el-form-item>
                             <el-form-item label="判断题分类">
                                <el-select v-model="form.judgmentCategorys" multiple placeholder="请选择分类">
                                   <el-option
                                     v-for="item in categorys"
                                     :key="item.id"
                                     :label="item.name"
                                     :value="item.id">
                                   </el-option>
                                </el-select>
                             </el-form-item>
                             <el-form-item label="判断题难度">
                                <el-select v-model="form.judgmentLevels" multiple placeholder="请选择难度">
                                   <el-option
                                     v-for="item in difficultyOption"
                                     :key="item.id"
                                     :label="item.name"
                                     :value="item.id">
                                   </el-option>
                                </el-select>
                             </el-form-item>
                             <el-form-item label="判断题知识点">
                                 <el-cascader placeholder="设置知识点" style="width:300px;"
                                    v-model="form.judgmentKnowledgeIds" clearable
                                    :options="options"
                                    :props="{expandTrigger: 'hover',
                                    multiple: true
                                    }"
                                    :show-all-levels="false"
                                    @change="handleChange"></el-cascader>
                             </el-form-item>
                         </el-form>
                     </el-tab-pane>
                     <el-tab-pane label="操作题" name="fourth">
                         <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                              <el-form-item label="操作题数量" >
                                   <el-input-number v-model="form.operationCount"  :min="0" :max="100"  label=""></el-input-number>
                               </el-form-item>
                               <el-form-item label="操作题分数" >
                                    <el-input-number v-model="form.operationScore"  :min="0" :max="100"  label=""></el-input-number>
                               </el-form-item>
                               <el-form-item label="操作题等级">
                                  <el-select v-model="form.operationLevels" multiple placeholder="请选择等级">
                                     <el-option
                                       v-for="item in difficultyOption"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                                     </el-option>
                                  </el-select>
                               </el-form-item>
                               <el-form-item label="操作题知识点">
                                   <el-cascader placeholder="设置知识点" style="width:300px;"
                                      v-model="form.operationKnowledgeIds" clearable
                                      :options="options"
                                      :props="{expandTrigger: 'hover',
                                      multiple: true
                                      }"
                                      :show-all-levels="false"
                                      @change="handleChange"></el-cascader>
                               </el-form-item>
                          </el-form>
                     </el-tab-pane>
                 </el-tabs>
            </template>
        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()" :disabled="subDisabled">保 存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>
<script>
    export default {
        props: [
            "item",
        ],
        components: {
        },
        data() {
            return {
                show: false,
                needRefreshParent: false,
                form: {
                    lessonType:'',
                    singleCount:0,
                    singleScore:0,
                    blanksCount:0,
                    blanksScore:0,
                    operationCount:0,
                    operationScore:0,
                    judgmentCount:0,
                    judgmentScore:0,
                },
                exam: {...this.item},
                lessonTypes:{},
                options: [],
                difficultyOption:[
                    {id:1,name:1},{id:2,name:2},{id:3,name:3},{id:4,name:4},{id:5,name:5}
                ],
                categorys:[],
                activeName: 'first',
                subDisabled:false,
            }
        },
        methods: {
            handleClick(tab, event) {
                //console.log(tab, event);
            },
            close() {
                this.$emit("close");
            },
            sub() {
                this.$checkForm(this.$refs.form).then(success => {
                    if (success) {
                        //校验通过，干什么....
                        //不知道咋了校验 不好使 用判断方式
                        if(this.form.lessonType ==''){
                            this.$showError("请输入编程语言再保存");
                            return;
                        }
                        if(this.form.singleKnowledgeIds != 'undefined'){// && this.form.singleKnowledgeIds.length > 0
                            for (const i in this.form.singleKnowledgeIds) {
                                let data = this.form.singleKnowledgeIds[i];
                                this.form.singleKnowledgeIds[i] = data[this.form.singleKnowledgeIds[i].length-1];
                            }
                        }
                        if(this.form.blanksKnowledgeIds != 'undefined'){
                            for (const i in this.form.blanksKnowledgeIds) {
                                let data = this.form.blanksKnowledgeIds[i];
                                this.form.blanksKnowledgeIds[i] = data[this.form.blanksKnowledgeIds[i].length-1];
                            }
                        }
                        if(this.form.operationKnowledgeIds != 'undefined'){
                            for (const i in this.form.operationKnowledgeIds) {
                                let data = this.form.operationKnowledgeIds[i];
                                this.form.operationKnowledgeIds[i] = data[this.form.operationKnowledgeIds[i].length-1];
                            }
                        }
                        if(this.form.judgmentKnowledgeIds != 'undefined'){
                            for (const i in this.form.judgmentKnowledgeIds) {
                                let data = this.form.judgmentKnowledgeIds[i];
                                this.form.judgmentKnowledgeIds[i] = data[this.form.judgmentKnowledgeIds[i].length-1];
                            }
                        }
                        this.subDisabled = true;
                        this.$ajaxPost("/question/generateQuestions", {
                            examId: this.exam.id,
                            form:this.form
                        }, (data) => {
                            this.$emit("submit", data.result);
                            this.showLoading = false;
                            this.needRefreshParent = true;
                            this.$showSuccess("保存成功");
                        })
                        return false;
                    } else {
                        this.$showError("请输入内容再保存");
                    }
                })
            },
            loadExams() {
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonType", (data) => {
                    this.lessonTypes = data.result;
                })
            },
            loadKnowledges() {
                this.$ajaxPost("/knowledge/knowledgeByTask",{form:{type:this.form.type}} , (data) => {
                    this.options = data.result;
                })
            },
            handleChange(value) {
                //console.log(value);
            },
            loadCategorys(){
                this.$ajaxGet("/trainCategory/listOption/1", (data) => {
                    this.categorys = data.result;
                })
            },

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadLessonTypes();
            this.loadKnowledges();
            this.loadCategorys();
        }
    }
</script>
